<template>
  <div id="home-survey-tabs">
    <div class="tabs-container" ref="tabsContainer">
      <div class="row flex-row no-bottom-margin" ref="flexRow">
        <div class="col s6" :data-step="survey.step" :style="`--step-color:${survey.stepColor}`"
          v-for="(survey) in surveys" :key="survey.key">
          <!-- :style="{ marginLeft: index === 0 ? '-12px' : '' }" -->
          <survey-card :disabled="survey.key !== 'home_profile' && homeProfileProgress !== '100'"
            v-if="survey.key !== 'energy_calculator'" :data-survey="survey" :data-perform-view-check="performViewCheck"
            @updateElView="$_updateElView" @updateFetch="$_updateSurveyShouldFetch" />
          <!-- :style="{ marginLeft: index === 0 ? '-12px' : '' }" -->
          <survey-card-energy :disabled="survey.key !== 'home_profile' && homeProfileProgress !== '100'" v-else
            :data-survey="survey" :data-perform-view-check="performViewCheck" @updateElView="$_updateElView"
            @updateFetch="$_updateSurveyShouldFetch" />
        </div>
      </div>
      <div class="empty-holder"></div>
    </div>
    <button class="btn-controls btn-prev btn-floating z-depth-2 waves-effect hide-on-med-and-up" @click="$_prev()">
      <i class="grey-text text-darken-2 material-icons-outlined">arrow_forward</i>
    </button>
    <button class="btn-controls btn-next btn-floating z-depth-2 waves-effect hide-on-med-and-up" @click="$_next()">
      <i class="grey-text text-darkne-2 material-icons-outlined">arrow_forward</i>
    </button>
  </div>
</template>
<script>
const getPosition = () => {
  let data = false
  try {
    data = localStorage.getItem('lastPosi')
  } catch (error) {
    return error
  }
  return data
}
import energyIcon from '@/assets/energy_calculator.svg'
import realOverview from '@/assets/overview_image.svg'
import waterPpl from '@/assets/water_shortage.svg'
import homeImage from '@/assets/home_profile.svg'
import windHazard from '@/assets/wind-hazard@2x.png'
import floodHazard from '@/assets/flood-hazard@2x.png'
import { mapActions } from 'vuex'
import SurveyCard from './SurveyCard'
import SurveyCardEnergy from './SurveyCard/SurveyCardEnergy'
export default {
  name: 'SurveyTabs',
  components: {
    SurveyCard,
    SurveyCardEnergy
  },
  props: {},
  data() {
    return {
      lastScrolled: getPosition(),
      surveys: [
        {
          key: "home_profile",
          title: "Home Profile",
          stepColor: '#536dfe',
          /*       description: "Something Small", */
          thumbnail: homeImage,
          route: 'HomeProfile',
          delete: "HomeProfile",
          tag: 0,
          step: 1,
        },
        {
          key: "wind_hazard",
          title: "Wind Hazard Assessment",
          stepColor: '#009688',
          /* description: "Something Small", */
          thumbnail: windHazard,
          route: "WindHazardSurvey",
          delete: "WindHazard",
          tag: 38,
          step: 2,
        },
        {
          key: "flood_hazard",
          title: "Flood Hazard Assessment",
          stepColor: '#009688',
          /* description: "Check The Water", */
          thumbnail: floodHazard,
          route: "FloodHazardSurvey",
          delete: "FloodHazard",
          tag: 39,
          step: 2,
        },
        {
          key: "water_hazard",
          title: "Water Shortage Hazard Assessment",
          stepColor: '#009688',
          /*    description: "Surf the waves", */
          thumbnail: waterPpl,
          route: "WaterHazardSurvey",
          delete: "WaterHazard",
          tag: 40,
          step: 2,
        },
        {
          key: "energy_calculator",
          title: "Household Carbon Footprint Calculator",
          stepColor: '#009688',
          /*  description: "Surf the waves", */
          thumbnail: energyIcon,
          route: "summary",
          delete: "summary",
          tag: false,
          step: 2,
        },
        {
          key: "assessment_summary",
          title: "Climate Change Home Risk Assessment Summary",
          stepColor: '#8bc34a',
          /*   description: "Surf the waves", */
          thumbnail: realOverview,
          route: "summary",
          tag: 10,
          step: 3,
        },
      ],
      viewInfo: {},
      performViewCheck: false,
      scrollListener: null,
      surveysFetched: [],
    };
  },
  mounted() {
    this.lastScrolled
      ? this.$refs.flexRow.scrollTo(this.lastScrolled, 0)
      : false
    setTimeout(() => {
      this.$refs.flexRow.addEventListener("scroll", this.$_checkCardsView, {
        passive: true,
      })

    }, 300);
  },
  beforeDestroy() {
    this.$refs.flexRow.removeEventListener(
      "scroll",
      this.$_checkCardsView,
      false
    );
  },
  computed: {
    homeProfileProgress() {
      return this.$store.getters["User/homeProfileProgress"]
    },
    isLastSurveyCardInViewX() {
      const lastKey = Object.keys(this.viewInfo)[
        Object.keys(this.viewInfo).length - 1
      ];

      if (!lastKey) return true;

      return this.viewInfo[lastKey].isInView;
    },
    isFirstSurveyCardInViewX() {
      const firstKey = Object.keys(this.viewInfo)[0];

      if (!firstKey) return true;

      return this.viewInfo[firstKey].isInView;
    },
  },
  methods: {
    ...mapActions("Surveys", ["setShouldFetch"]),
    $_updateSurveyShouldFetch(val) {
      this.surveysFetched.push(val);
      if (this.surveysFetched.length >= this.surveys.length) {
        this.setShouldFetch(false);
      }
    },
    $_checkCardsView(e) {
      this.lastScrolled = e.target.scrollLeft
      localStorage.setItem('lastPosi', e.target.scrollLeft)
      /*   this.performViewCheck = !this.performViewCheck; */
    },
    $_next() {
      this.$refs.flexRow.scrollTo(this.lastScrolled + (this.$refs.flexRow.clientWidth - 50), 0)
    },
    $_prev() {
      this.$refs.flexRow.scrollTo((this.lastScrolled - (this.$refs.flexRow.clientWidth - 50)), 0)
    },
    $_updateElView(val) {
      this.$set(this.viewInfo, val.key, val);
    },
  },
};
</script>
<style lang="scss" scoped>
#home-survey-tabs {
  position: relative;
  margin: 0 -16px;

  .tabs-container {
    .flex-row {
      padding: 24px 16px 12px;
      display: flex;
      overflow-x: scroll;
      scroll-behavior: smooth;
      margin-bottom: 0;

      @media screen and (min-width: 768px) {
        flex-wrap: wrap;
      }

      .col {
        /*      margin-left:0px;
        min-width: 50vw; */
        margin-left: 0px;
        max-width: 300px;
        width: 50%;
        min-width: 250px;

        @media screen and (min-width: 768px) {
          width: 33.33% !important;
          min-width: 33.33% !important;
        }
      }
    }
  }

  .empty-holder {
    flex-shrink: 0;
    height: 10px;
    width: 1px;
  }

  .btn-controls {
    height: 40px;
    width: 40px;
    position: absolute;

    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    color: #888888;
    border: none;
  }

  .btn-prev {
    top: 50%;
    left: 0;
    transform: translate(0%, -50%);

    i {
      transform: rotate(180deg);
    }
  }

  .btn-next {
    top: 50%;
    right: 0;
    transform: translate(0%, -50%);
  }
}
</style>
<style scoped lang="scss">
.surverys-tab-survey-card.card[data-step="1"]:before {
  content: ' ';
  border: 2px solid #536dfe;
  border-bottom: none;
  position: absolute;
  left: -6px;
  top: -20px;
  width: calc(100% + 12px);
  height: 28px;
  border-radius: 5px 5px 0 0;
}

.surverys-tab-survey-card.card[data-step="1"]:after {
  text-align: center;
  content: 'Step 1';
  position: absolute;
  color: #536dfe;
  top: -31px;
  left: 50%;
  width: 90px;
  background: white;
  transform: translateX(-50%);
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  border-radius: 7px;
  padding: 3px 0;
  font-weight: 600;
}

.col.s6[data-step='2']:nth-of-type(2) .card:before {
  content: ' ';
  border: 2px solid #009688;
  border-bottom: none;
  position: absolute;
  left: -6px;
  top: -20px;
  width: calc(100% + 12px);
  height: 28px;
  border-radius: 5px 0px 0 0;
  border-right: 0px;
}

.col.s6[data-step='2']:nth-of-type(3) .card:before {
  content: ' ';
  border-top: 2px solid #009688;
  border-bottom: none;
  position: absolute;
  left: -18px;
  top: -20px;
  width: calc(100% + 30px);
  height: 28px;
  border-radius: 0x 0px 0 0;
  border-right: 0px;
}

.col.s6[data-step='2']:nth-of-type(4) .card:before {
  content: ' ';
  border-top: 2px solid #009688;
  border-bottom: none;
  position: absolute;
  left: -15px;
  top: -20px;
  width: calc(100% + 30px);
  height: 28px;
  border-radius: 0x 0px 0 0;
  border-right: 0px;
}

.col.s6[data-step='2']:nth-of-type(5) .card:before {
  content: ' ';
  border: 2px solid #009688;
  border-bottom: none;
  position: absolute;
  left: -12px;
  top: -20px;
  width: calc(100% + 20px);
  height: 28px;
  border-radius: 0px 5px 0 0;
  border-left: 0px;
}

.col.s6[data-step='2']:nth-of-type(3):before {
  @media screen and (min-width: 768px) {
    content: 'arrow_right';
    font-family: 'Material Icons Outlined';
    font-size: 25px;
    position: absolute;
    right: 0;
    top: -6px;
    color: #009688;
  }
}

.col.s6[data-step='2']:nth-of-type(4) {
  position: relative;

  &::before {
    @media screen and (min-width: 768px) {
      content: 'arrow_left';
      font-family: 'Material Icons Outlined';
      font-size: 25px;
      position: absolute;
      left: -14px;
      color: #009688;
      z-index: 9;
      top: -29.5px;
    }
  }
}

.col.s6[data-step='2']:nth-of-type(3) .card:after {
  text-align: center;
  content: 'Step 2';
  position: absolute;
  color: #009688;
  top: -31px;
  left: 50%;
  width: 90px;
  background: white;
  transform: translateX(-50%);
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  border-radius: 7px;
  padding: 3px 0;
  font-weight: 600;

  @media screen and (max-width: 768px) {
    z-index: 9;
    left: 110%;
  }
}

.col.s6[data-step='2']:nth-of-type(4) .card:after {
  @media screen and (min-width: 768px) {
    text-align: center;
    content: 'Step 2';
    position: absolute;
    color: #009688;
    top: -31px;
    left: 50%;
    width: 90px;
    background: white;
    transform: translateX(-50%);
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 1px;
    border-radius: 7px;
    padding: 3px 0;
    font-weight: 600;
  }
}

.surverys-tab-survey-card.card[data-step="3"]:before {
  content: ' ';
  border: 2px solid #8bc34a;
  border-bottom: none;
  position: absolute;
  left: -8px;
  top: -20px;
  width: calc(100% + 16px);
  height: 28px;
  border-radius: 5px 5px 0 0;
}

.surverys-tab-survey-card.card[data-step="3"]:after {
  text-align: center;
  content: 'Step 3';
  position: absolute;
  color: #8bc34a;
  top: -31px;
  left: 50%;
  width: 90px;
  background: white;
  transform: translateX(-50%);
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  border-radius: 7px;
  padding: 3px 0;
  font-weight: 600;
}

@media screen and (min-width: 768px) {

  .col.s6[data-step='2']:nth-of-type(4),
  .col.s6[data-step='2']:nth-of-type(5),
  .col.s6[data-step='3']:nth-of-type(6) {
    margin-top: 24px;
  }
}
</style>